import { transport } from 'config/transport';

export function callApiGetListOfThuDauNam(gradeId) {
    return transport.get(`/mamnon/thuhocsinh/thudaunam`, { params: { gradeId } });
}
